

import type { ConsentCategory } from '../types';

const CONSENT_KEY = 'twiggy_consent';

export class ConsentManager {
  private categories: Set<ConsentCategory>;
  private hasUserConsent = false;

  constructor(defaultCategories: ConsentCategory[] = []) {
    this.categories = new Set(defaultCategories);
    this.load();
  }

  
  private load(): void {
    if (typeof localStorage === 'undefined') return;

    try {
      const stored = localStorage.getItem(CONSENT_KEY);
      if (stored) {
        const data = JSON.parse(stored);
        this.categories = new Set(data.categories || []);
        this.hasUserConsent = data.hasUserConsent || false;
      }
    } catch {
      
    }
  }

  
  private save(): void {
    if (typeof localStorage === 'undefined') return;

    try {
      localStorage.setItem(
        CONSENT_KEY,
        JSON.stringify({
          categories: Array.from(this.categories),
          hasUserConsent: this.hasUserConsent,
          updatedAt: new Date().toISOString()
        })
      );
    } catch {
      
    }
  }

  
  grant(categories: ConsentCategory[]): void {
    categories.forEach(c => this.categories.add(c));
    this.hasUserConsent = true;
    this.save();
  }

  
  revoke(categories: ConsentCategory[]): void {
    categories.forEach(c => this.categories.delete(c));
    this.hasUserConsent = true;
    this.save();
  }

  
  hasCategory(category: ConsentCategory): boolean {
    return this.categories.has(category);
  }

  
  getCategories(): ConsentCategory[] {
    return Array.from(this.categories);
  }

  
  hasExplicitConsent(): boolean {
    return this.hasUserConsent;
  }

  
  reset(defaultCategories: ConsentCategory[] = []): void {
    this.categories = new Set(defaultCategories);
    this.hasUserConsent = false;
    this.save();
  }

  
  allowsAnalytics(): boolean {
    return this.categories.has('analytics') || this.categories.has('necessary');
  }

  
  allowsMarketing(): boolean {
    return this.categories.has('marketing') || this.categories.has('personalization');
  }
}
